import React from 'react';
import styled from 'styled-components';

import { PencilIcon } from '~/atomic/atom/icon/PencilIcon';
import { bookModerationActions } from '~/atomic/page/book/Book/bookModeration/bookModeration.slice';
import { BookModerationModal } from '~/atomic/page/book/Book/bookModeration/BookModerationModal';
import { isLoggedUserAdminSelector } from '~/feature/user/user.selector';
import { useAppDispatch, useAppSelector } from '~/store';

export const BookModerationIcon = () => {
  const dispatch = useAppDispatch();
  const isAdmin = useAppSelector(isLoggedUserAdminSelector);

  if (!isAdmin) {
    return null;
  }

  const openModerationBookHandler = () => {
    dispatch(bookModerationActions.setIsOpenModerationBookModal(true));
  };

  return (
    <>
      <SCBookEditAdmin>
        <SCPencilIcon
          onClick={openModerationBookHandler}
        />
      </SCBookEditAdmin>
      <BookModerationModal />
    </>
  );
};

const SCBookEditAdmin = styled.span`
  display: inline-flex;
  height: 20px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  padding-left: 4px;
`;

const SCPencilIcon = styled(PencilIcon)`
  font-size: 18px;
  color: var(--black-color);
`;
